import React, { useEffect, useRef, memo } from 'react'
import { loadModules } from 'esri-loader'
import { WebMapContainer } from './styles'

const ic_pin = require('App/assets/images/ic_pin.png')

const compareProps = (prev, next) => {
  if (prev.pos !== next.pos) {
    return false
  } else {
    return true
  }
}

const MapView = memo(({ pos, field, fn, selectable }) => {
  const mapRef = useRef()
  const { y, x } = pos

  useEffect(() => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(['esri/Map', 'esri/views/MapView', 'esri/Graphic'], { css: true })
      .then(([ArcGISMap, MapView, Graphic]) => {
        const map = new ArcGISMap({
          basemap: 'streets-vector'
        })

        // load the image marker at the ref's DOM node
        const pin = new Graphic({
          geometry: {
            type: 'point',
            longitude: parseFloat(x),
            latitude: parseFloat(y)
          },
          symbol: {
            type: 'picture-marker',
            url: ic_pin,
            width: '40px',
            height: '54px',
            yoffset: '27px'
          }
        })

        // load the map view at the ref's DOM node
        const view = new MapView({
          container: mapRef.current,
          map: map,
          center: [parseFloat(x), parseFloat(y)],
          zoom: 13
        })

        // mount the pin marker to the map
        view.graphics.add(pin)

        if (selectable) {
          view.on('click', (event) => {
            // X is LONGitude, Y is LATitude
            const { mapPoint: { longitude, latitude } } = event
            let newCoordinate = { ...pos }
            newCoordinate.x = longitude
            newCoordinate.y = latitude
            fn(newCoordinate, field)
          })
        }

        return () => {
          if (view) {
            // destroy the map view
            view.container = null
          }
        }
      })
  })

  return (
    <WebMapContainer ref={mapRef} />
  )
}, compareProps)

export default MapView
